/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMode } from './PaymentMode';
import {
    PaymentModeFromJSON,
    PaymentModeFromJSONTyped,
    PaymentModeToJSON,
} from './PaymentMode';

/**
 * Representation of a Payment Mode List
 * @export
 * @interface PaymentModeList
 */
export interface PaymentModeList {
    /**
     * List of payment modes
     * @type {Array<PaymentMode>}
     * @memberof PaymentModeList
     */
    paymentModes?: Array<PaymentMode>;
}

/**
 * Check if a given object implements the PaymentModeList interface.
 */
export function instanceOfPaymentModeList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentModeListFromJSON(json: any): PaymentModeList {
    return PaymentModeListFromJSONTyped(json, false);
}

export function PaymentModeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentModeList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentModes': !exists(json, 'paymentModes') ? undefined : ((json['paymentModes'] as Array<any>).map(PaymentModeFromJSON)),
    };
}

export function PaymentModeListToJSON(value?: PaymentModeList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentModes': value.paymentModes === undefined ? undefined : ((value.paymentModes as Array<any>).map(PaymentModeToJSON)),
    };
}

